import type { ChannelInfo, ChannelKey } from './types';

export const FE_CHANNELS: ChannelInfo[] = [
  { key: 'native_ios',      label: 'App (iOS)',     device: 'ios',        family: 'App' },
  { key: 'native_android',  label: 'App (Android)', device: 'android',    family: 'App' },
  { key: 'appless_ios',     label: 'Web (iOS)',     device: 'ios',        family: 'Web' },
  { key: 'appless_android', label: 'Web (Android)', device: 'android',    family: 'Web' },
  { key: 'spectacles',      label: 'Specs',         device: 'spectacles', family: 'Specs' },
];

export const BE_TO_FE_CHANNEL: Record<string, ChannelKey> = {
  native_ios: 'native_ios',
  native_android: 'native_android',
  appclip_ios: 'appless_ios',
  webxr_android: 'appless_android',
  spectacles: 'spectacles',
};

export const BAR_MAX_MB = 250;
